module.exports = "<iframe src=\"./assets/imgs/TermsAndConditions.pdf#toolbar=0\" width=\"100%\" [height]=\"screenHeight + 'px'\">\n</iframe>\n"